/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_CLIENT_FAULTS } from '../../actions.type'
import {
  CREATE_CLIENT_FAULT,
  REMOVE_CLIENT_FAULT,
  SET_CLIENT_FAULT_ALL_REQUEST,
  SET_CLIENT_FAULT_ALL_VALUE,
  UPDATE_CLIENT_FAULT
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  clientFaultAllValue: (state) => state.all.value,
  clientFaultAllRequest: (state) => state.all.request,
  clientFaultAllById: (state) => keyBy(state.all.value, 'id'),
  clientFaultAllByGroupId: (state) =>
    keyBy(state.all.value, 'clientFaultGroup.id')
}

const actions = {
  async [FETCH_CLIENT_FAULTS]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('client-fault', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_CLIENT_FAULT_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_CLIENT_FAULT_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_CLIENT_FAULT_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_CLIENT_FAULT_ALL_VALUE, data)
    } catch (e) {
      commit(SET_CLIENT_FAULT_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_CLIENT_FAULT({ commit }, value) {
    commit(CREATE_CLIENT_FAULT, value)
  },

  async SOCKET_UPDATE_CLIENT_FAULT({ commit }, value) {
    commit(UPDATE_CLIENT_FAULT, value)
  },

  async SOCKET_REMOVE_CLIENT_FAULT({ commit }, id) {
    commit(REMOVE_CLIENT_FAULT, id)
  }
}

const mutations = {
  [SET_CLIENT_FAULT_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_CLIENT_FAULT_ALL_VALUE](state, clientFaults) {
    state.all.value = clientFaults
  },
  [UPDATE_CLIENT_FAULT](state, updatedClientFault) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedClientFault.id }),
      1,
      updatedClientFault
    )
  },
  [CREATE_CLIENT_FAULT](state, createdClientFault) {
    state.all.value.push(createdClientFault)
  },
  [REMOVE_CLIENT_FAULT](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
